import { render } from "./RefundRequestComponent.vue?vue&type=template&id=8f3e5f06"
import script from "./RefundRequestComponent.vue?vue&type=script&lang=js"
export * from "./RefundRequestComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__